import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {AppRouter} from "./routes/AppRouter";
import {Toaster} from "react-hot-toast";
import './stylesheets/index.scss';
import {Provider} from "react-redux";
import store from "./store";

const root = ReactDOM.createRoot(document.getElementById('mex-root'));

root.render(
    <Provider store={store}>
        <React.StrictMode>
            <Toaster/>
            <AppRouter/>
        </React.StrictMode>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
